module.exports = __webpack_public_path__ + "static/connect_02-ad2fc1ac65abef82ae4d489788be90e5.png";